<template>
  <BaseLayout>
    <div class="row" v-if="order">
      <div class="col-xl-8">
        <div class="mb-4 d-flex justify-content-between">
          <h5>Order Title: {{ order.title }}</h5>
          <h5>Order ID: {{ order.id }}</h5>
        </div>
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content" id="kt_chat_content">
          <div class="kt-chat">
            <div class="kt-portlet kt-portlet--head-lg kt-portlet--last">
              <div class="kt-portlet__head">
                <div class="kt-chat__head">
                  <div class="kt-chat__left"></div>
                  <div class="kt-chat__center">
                    <div class="kt-chat__label">
                      <p class="kt-chat__title">{{ user.first_name + ' ' + user.last_name }}</p>
                      <span class="kt-chat__status">
                        <span class="kt-badge kt-badge--dot kt-badge--success"></span> Active
                      </span>
                    </div>
                    <div class="kt-chat__pic kt-hidden">
                      <span
                        class="kt-media kt-media--sm kt-media--circle"
                        data-toggle="kt-tooltip"
                        data-placement="right"
                        title="Jason Muller"
                        data-original-title="Tooltip title"
                      >
                        <img
                          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                          alt="image"
                        />
                      </span>
                      <span
                        class="kt-media kt-media--sm kt-media--circle"
                        data-toggle="kt-tooltip"
                        data-placement="right"
                        title="Nick Bold"
                        data-original-title="Tooltip title"
                      >
                        <img
                          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                          alt="image"
                        />
                      </span>
                      <span
                        class="kt-media kt-media--sm kt-media--circle"
                        data-toggle="kt-tooltip"
                        data-placement="right"
                        title="Milano Esco"
                        data-original-title="Tooltip title"
                      >
                        <img
                          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                          alt="image"
                        />
                      </span>
                      <span
                        class="kt-media kt-media--sm kt-media--circle"
                        data-toggle="kt-tooltip"
                        data-placement="right"
                        title="Teresa Fox"
                        data-original-title="Tooltip title"
                      >
                        <img
                          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                          alt="image"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="kt-chat__right"></div>
                </div>
              </div>
              <div class="kt-portlet__body">
                <div
                  class="kt-scroll kt-scroll--pull"
                  data-mobile-height="300"
                  style="height: 280px;overflow-y: scroll;"
                >
                  <div class="kt-chat__messages">
                    <template v-for="message in messages">
                      <div class="kt-chat__message" :key="message.id" v-if="message.owner.id !== user.id">
                        <div class="kt-chat__user">
                          <span class="kt-media kt-media--circle kt-media--sm">
                            <img
                              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                              alt="image"
                            />
                          </span>
                          <a href="#" class="kt-chat__username">{{ message.owner.first_name + ' ' + message.owner.last_name }}</a>
                          <span class="kt-chat__datetime">{{ message.created_at }}</span>
                        </div>
                        <div class="kt-chat__text kt-bg-light-success">
                          {{ message.content }}
                          <div v-if="message.attachment" class="d-flex align-items-center bg-light rounded mt-2">
                            <div style="background-color: #fdf1e5;" class="px-3 py-2">
                              <i class="flaticon2-photograph"></i>
                            </div>
                            <div class="flex-grow-1 px-2 text-left px-3 py-2">{{ message.attachment.name }}</div>
                            <a @click.prevent="download(message.attachment.id, message.attachment.name)" href="#" class="px-3 py-2">
                              <i class="flaticon2-download"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="kt-chat__message kt-chat__message--right" :key="message.id" v-else>
                        <div class="kt-chat__user">
                          <span class="kt-chat__datetime">{{ message.created_at }}</span>
                          <a href="#" class="kt-chat__username">You</a>
                          <span class="kt-media kt-media--circle kt-media--sm">
                            <img
                              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                              alt="image"
                            />
                          </span>
                        </div>
                        <div class="kt-chat__text kt-bg-light-brand">
                          {{ message.content }}
                          <div v-if="message.attachment" class="d-flex align-items-center bg-light rounded mt-2">
                            <div style="background-color: #fdf1e5;" class="px-3 py-2">
                              <i class="flaticon2-photograph"></i>
                            </div>
                            <div class="flex-grow-1 px-2 text-left px-3 py-2">{{ message.attachment.name }}</div>
                            <a @click.prevent="download(message.attachment.id, message.attachment.name)" href="#" class="px-3 py-2">
                              <i class="flaticon2-download"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="kt-portlet__foot">
                <div class="kt-chat__input">
                  <div class="kt-chat__editor">
                    <input type="file" ref="file" @change="change" style="display: none;">
                    <textarea style="height: 50px;" placeholder="Type here..." v-model="message"></textarea>
                      <div v-if="file" class="kt-chat__text kt-bg-light-brand" style="width: 40%;">
                        <div class="d-flex align-items-center bg-light rounded mt-2">
                          <div style="background-color: #fdf1e5;" class="px-3 py-2">
                            <i class="flaticon2-photograph"></i>
                          </div>
                          <div class="flex-grow-1 px-2 text-left px-3 py-2">{{ file.name }}</div>
                          <a @click.prevent="remove" href="#" class="px-3 py-2">
                            <i class="flaticon2-delete"></i>
                          </a>
                        </div>
                      </div>
                  </div>
                  <div class="kt-chat__toolbar">
                    <div class="kt_chat__tools">
                      <a @click.prevent="upload" href="#">
                        <i class="flaticon2-photograph"></i>
                      </a>
                    </div>
                    <div class="kt_chat__actions">
                      <button
                        type="button"
                        class="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply"
                        @click="submit"
                      >reply</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-5"></div>
        <div class="kt-portlet">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <h3 class="kt-portlet__head-title">Status</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="kt-section">
              <div class="kt-section__content">
                <div class="d-flex justify-content-between align-items-center">
                  <span
                    class="kt-badge kt-badge--success kt-badge--inline kt-badge--pill px-4 py-2"
                  >{{ order.status }}</span>
                  <small>Updated 1 day ago</small>
                </div>
                <hr />
                <div class="d-flex">
                  <div class>
                    <i class="flaticon2-download"></i>
                  </div>
                  <div class="flex-grow-1 ml-3">
                    <h5>
                      {{ order.due_date }}
                      <br />
                      <small>Estimated delivery</small>
                    </h5>
                    <h6>Started: {{ order.create_date }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="kt-portlet__foot">
            <h5>Task price: ${{ order.total }}</h5>
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/BaseLayout.vue';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'Message',
  components: {
    BaseLayout,
  },
  data() {
    return {
      message: '',
      order: null,
      file: null,
    };
  },
  computed: {
    ...mapGetters({
      messages: 'message/messages',
      user: 'auth/user'
    }),
  },
  methods: {
    ...mapActions({
      getAllMessage: 'message/getAllMessage',
      storeMessage: 'message/storeMessage',
      downloadAttachment: 'message/downloadAttachment',
    }),
    submit() {
      const data = new FormData();
      if (this.file) {
        data.append('attachment', this.file);
      }
      data.append('content', this.message);
      this.storeMessage({
        id: this.$route.params.id,
        data: data
      }).then(() => {
        this.file = null;
      }).catch((error) => {
        let message = 'Something wents wrong!';

        if (error.response.data.errors.attachment) {
          message = error.response.data.errors.attachment[0];
        }

        if (error.response.data.errors.content) {
          message = error.response.data.errors.content[0];
        }
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: message,
        });
      });

      this.message = '';
    },
    upload() {
      this.file = null;
      this.$refs.file.click();
    },
    change(event) {
      this.file = event.target.files[0];
    },
    remove() {
      this.file = null;
    },
    download(attachmentId, attachmentName) {
      this.downloadAttachment({
        orderId: this.$route.params.id,
        attachmentId: attachmentId
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', attachmentName);
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Something wents wrong!',
        });
      });
    }
  },
  created() {
    this.getAllMessage({
      id: this.$route.params.id,
    }).catch(() => {
      this.$router.push({
        name: 'home',
      });
    });

    axios.get('orders/' + this.$route.params.id)
      .then((response) => {
        this.order = response.data;
      });
  },
};
</script>
